var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClientPortalIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.811,
    height: 16.127,
    viewBox: "0 0 22.811 16.127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "portal_filled_-_green",
    "data-name": "portal filled - green",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42"
  }, /*#__PURE__*/React.createElement("g", {
    id: "laptop_md_copy_2",
    "data-name": "laptop md copy 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M0,3.279A2.422,2.422,0,0,1,2.432.86H14.869A2.422,2.422,0,0,1,17.3,3.279v9.142a2.422,2.422,0,0,1-2.432,2.419H2.432A2.422,2.422,0,0,1,0,12.422Zm1.624,0a.8.8,0,0,1,.807-.8H14.869a.8.8,0,0,1,.807.8v8.071a.8.8,0,0,1-.807.8H2.432a.8.8,0,0,1-.807-.8Z",
    transform: "translate(0 -0.86)",
    fill: "#fff",
    stroke: "#3d896e",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M.3.182H14.077L13.963,9.75H.3Z",
    transform: "translate(1.501 1.566)",
    fill: "#3d896e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52",
    transform: "translate(12.306 6.111)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M6.689,12.376a.593.593,0,0,1-.616.679H.626a.593.593,0,0,1-.616-.679,3.412,3.412,0,0,1,6.684,0Z",
    transform: "translate(1.426 -3.513)",
    fill: "#3d896e",
    stroke: "#fff",
    strokeWidth: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M15.119,12.995h-1.08c-.005-.068-.016-.13-.026-.2a4.465,4.465,0,0,0-.793-1.779,2.07,2.07,0,0,1,2.472,1.3.536.536,0,0,1-.569.673Z",
    transform: "translate(-6.932 -2.403) rotate(-7)",
    fill: "#3d896e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M12.79,6.73a1.15,1.15,0,1,0-1.15-1.15A1.151,1.151,0,0,0,12.79,6.73Z",
    transform: "translate(-5.066 -0.4)",
    fill: "#3d896e",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M6.86,3.68A1.85,1.85,0,1,1,5.01,1.83,1.85,1.85,0,0,1,6.86,3.68Z",
    transform: "translate(-0.227 0.419)",
    fill: "#3d896e",
    stroke: "#fff",
    strokeWidth: 0.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientPortalIconActive);
export default __webpack_public_path__ + "static/media/client-portal-icon-active.03012a782e0d1a52aad0bda4c30e1880.svg";
export { ForwardRef as ReactComponent };